var plugin_rtlignore_default = {
  "alignLeft": "kkswy",
  "textWrapNowrap": "b5DT5",
  "alignRight": "_0slBc",
  "alignCenter": "t0g9p",
  "sizeFullWidth": "_9ofM0",
  "renderedInTable": "aF2zv",
  "sizeOriginal": "F4ItD",
  "sizeContent": "ALEap",
  "sizeSmall": "_7cI1e",
  "sizeSmallCenter": "_80Z16",
  "flex": "TCN17",
  "atomic": "LgEVf",
  "embed": "pAipa",
  "horizontalScrollbar": "mz9K2",
  "pluginContainerMobile": "WMq10"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
